import React, { Component } from "react";
import { connect } from "react-redux";

import { TabNavigation, Carousel, NextStepButton, PrevStepButton, Logo } from "components";
import InvoiceItem from "./invoice-item";
import { MOVE_TAB } from "actions";

class Tab3B extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.activeTab === "tab3a" && nextProps.activeTab === "tab3b") {
      return true;
    }
    return false;
  }
  render() {
    const props = this.props;
    console.log(props);
    return (
      <div className="form_steps">
        <div className="form_steps--inner">
          <div className="full_column">
            <Logo />
            <TabNavigation />
            <div className="three_blocks">
              <div className="width-1-3">
                <div className="inner_block">
                  <PrevStepButton onClick={props.moveToPreviousTab} text={props.domain.Strings.tab3BPrevBtn} />
                  <h2 className="three_blocks--title">{props.domain.Strings.tab3BTitle}</h2>
                  <p>{props.domain.Strings.tab3BSubTitle}</p>
                  <NextStepButton text={props.domain.Strings.tab3BNextBtn} hideForMedium onClick={props.moveToNextTab} />
                </div>
              </div>
              <div className="width-2-3">
                {props.countries.length > 0 && (
                  <Carousel
                    textPrev={props.domain.Strings.tab3BCarouselPrev}
                    textNext={props.domain.Strings.tab3BCarouselNext}
                    children={props.countries.map(country => {
                      return <InvoiceItem key={country.value} countryValue={country.value} />;
                    })}
                  />
                )}
              </div>
              <div className="three_blocks--info">
                <p>
                  <strong>{props.domain.Strings.carouselHelpTextStrong}</strong> {props.domain.Strings.carouselHelpText}
                </p>
              </div>
              <NextStepButton text={props.domain.Strings.tab3BNextBtn} showForMedium onClick={props.moveToNextTab} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    moveToPreviousTab: () => dispatch({ type: MOVE_TAB, dir: "back", from: ownProps.tab }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab3B);
